import React from 'react';
import { NEXT_PRICE, PRICE_ARS, PROMO_END_AT } from '../data/config';
import { useCountdown } from '../hooks/useCountdown';
import { padTime } from '../utils/promo';
import { Section } from './Shared';
import { Bat, Pumpkin, Star } from './HalloweenDecor';
export function OfferCountdown() {
  const timeLeft = useCountdown(PROMO_END_AT);
  const units = timeLeft ? [...(timeLeft.days > 0 ? [{
    label: 'Días',
    value: timeLeft.days
  }] : []), {
    label: 'Horas',
    value: timeLeft.hours
  }, {
    label: 'Min',
    value: timeLeft.minutes
  }, {
    label: 'Seg',
    value: timeLeft.seconds
  }] : [];
  return <Section tone="cream" innerClassName="!py-12 md:!py-16" data-id="element-173" data-mp="1l81m3ncc9oe0">
      <div className="relative mx-auto max-w-4xl overflow-hidden rounded-3xl bg-brand-violet px-6 py-10 text-center text-brand-cream md:px-12 md:py-14" data-id="element-174" data-mp="1q7o1a2bq9epg">
        <Pumpkin className="absolute -bottom-3 left-4 w-14 text-brand-orange/30 md:w-20" data-id="element-175" data-mp="2wnglsyvxmuct" />
        <Bat className="absolute right-6 top-6 w-12 text-white/10 md:w-16" data-id="element-176" data-mp="31li076iey5hy" />
        <Star className="absolute left-[12%] top-8 w-3 text-brand-orange/60" data-id="element-177" data-mp="26q2wj8c3ony1" />

        <h2 className="relative text-balance text-[28px] font-extrabold leading-tight text-brand-cream md:text-4xl" data-id="element-178" data-mp="21q6uhemyr6l4">
          🎃 Tu próxima tarde creativa puede empezar hoy
        </h2>
        <p className="relative mx-auto mt-3 max-w-xl text-base leading-relaxed text-brand-cream/85 md:text-lg" data-id="element-179" data-mp="1rsk9qbizgkt8">
          Elegí el personaje y organizá los materiales con tiempo para disfrutar el armado.
        </p>

        {timeLeft ? <div className="relative mt-8" role="timer" aria-live="off" data-id="element-180" data-mp="1izyz5ipi9kfh">
            <p className="mb-3 text-sm font-bold text-brand-cream/80" data-id="element-181" data-mp="1e0w2aljoikil">El precio de lanzamiento termina en:</p>
            <div className="flex justify-center gap-2 md:gap-4" data-id="element-182" data-mp="192kra7hne3ys">
              {units.map(unit => <div key={unit.label} className="flex flex-col items-center" data-id="element-183" data-mp="142ybpreckbmt">
                  <span className="min-w-[60px] rounded-xl bg-white px-3 py-2 font-display text-3xl font-extrabold tabular-nums text-brand-violet md:min-w-[84px] md:text-5xl" data-id="element-184" data-mp="1452jikfd9usd">
                    {padTime(unit.value)}
                  </span>
                  <span className="mt-1.5 text-xs font-bold uppercase tracking-wide text-brand-cream/75" data-id="element-185" data-mp="ufm26j69jln8">{unit.label}</span>
                </div>)}
            </div>
            <p className="mx-auto mt-6 inline-flex items-center gap-2 rounded-full bg-brand-orange px-5 py-2 text-sm font-bold text-brand-violet md:text-base" data-id="element-186" data-mp="ghxivfrugmka">
              ⏰ Lanzamiento: {PRICE_ARS} · Después aumenta a {NEXT_PRICE}
            </p>
          </div> : <p className="relative mt-8 inline-block rounded-2xl bg-white px-6 py-3 font-display text-xl font-extrabold text-brand-violet md:text-2xl" data-id="element-187" data-mp="1d4k0lt8lu5nt">
            Precio del kit: {PRICE_ARS}
          </p>}
      </div>
    </Section>;
}